import { IServices } from "@netent/origin";
import { IPlayUIState } from "@netent/playui";
import { Store } from "redux";
import { IAdapterConfig } from "..";
import { IStoreAction, IStoreState } from "../store";
import { autoplayState } from "./autoplay";
import { balanceState } from "./balance";
import { betState } from "./bet";
import { clockState } from "./clock";
import { currencyState } from "./currency";
import { gameHistoryState } from "./gameHistory";
import { gameInformationState } from "./gameInformation";
import { gameRulesState } from "./gameRules";
import { homeState } from "./home";
import { leftHandModeState } from "./leftHandMode";
import { menuState } from "./menu";
import { moneyTypesState, moneyTypeState } from "./moneyTypes";
import { paytableState } from "./paytable";
import { playForFunIndicatorState } from "./playForFunIndicator";
import { pluginState } from "./plugin";
import { quickSpinState } from "./quickSpin";
import { settingsState } from "./settings";
import { spinState } from "./spin";
import { totalWinState } from "./totalWin";
import { volumeState } from "./volume";
import { winState } from "./win";

export const initState = (
  services: IServices,
  config: IAdapterConfig,
  store: Store<IStoreState, IStoreAction>
): IPlayUIState => {
  const { gameName, gameProducer } = config;

  return {
    view: null,
    moneyTypes: moneyTypesState(services, store),
    moneyType: moneyTypeState(services, store),
    autoplay: autoplayState(services, store),
    balance: balanceState(services, store),
    bet: betState(services, store),
    clock: clockState(services, store),
    currency: currencyState(services, store),
    gameHistory: gameHistoryState(services, store),
    gameInformation: {
      ...gameInformationState(services, store),
      gameName,
      gameProducer
    },
    gameRules: gameRulesState(services, store),
    home: homeState(services, store),
    leftHandMode: leftHandModeState(services, store),
    menu: menuState(services, store),
    paytable: paytableState(services, store),
    playForFunIndicator: playForFunIndicatorState(services, store),
    plugin: pluginState(services, store),
    quickSpin: quickSpinState(services, store),
    settings: settingsState(services, store),
    spin: spinState(services, store),
    totalWin: totalWinState(services, store),
    volume: volumeState(services, store),
    win: winState(services, store)
  };
};
